import { type FC } from 'react';
import { Button } from '@direct-frontend/components';

type SettingsButtonOpenInSiteStubProps = {};

export const SettingsButtonOpenInSiteStub: FC<SettingsButtonOpenInSiteStubProps> = ({}) => (
    <Button size="m" color="normal" width="max" isDisabled>
        Показать на сайте
    </Button>
);
